import { RectSize } from "../../../utils/RectSize";
import { AppSettings } from "../../managers/AppSettings";
import { LoaderFileKeys } from "../../constant/AppConstants";
import { ResultsListItem } from "./ResultsListItem";
import { ResultsHeaderItem } from "./ResultsHeaderItem";
import { TextureData, TrickData } from "../../../types/types";
import { BubbleListItemData, DealsListItem } from "./DealsListItem";
import { TrumpSuit } from "../../state/TableStateMachine";
import { DealsHeaderItem } from "./DealsHeaderItem";
import { SideScoreItem } from "./SideScoreItem";
import { ScreenManager } from "../../../managers/ScreenManager";
import { ApplyScalingBias } from "../../../utils/ApplyScalingBias";
import { LabelIconButton } from "../../../ui/LabelIconButton";
import { TricksHeaderItem } from "./TricksHeaderItem";
import { TricksListItem } from "./TricksListItem";
import { ScrollPaneTitledListContent } from "./ScrollPaneTitledListContent";
import { AppLocalization } from "../../localization/AppLocalization";
import { ThemeDataManager } from "../../managers/ThemeDataManager";
import { LayoutDataManager } from "../../managers/LayoutDataManager";


export class DealCompleteTricksContent
    extends ScrollPaneTitledListContent
{
    public nodeGeneralLoc: any;
    private delimiterLineAlpha: number;
    

    public override Init(): void
    {
        super.Init();

        this.delimiterLineAlpha = LayoutDataManager.GetSharedData().general.screen.item.delimiterLine.alpha;
        
        this.nodeLoc = AppLocalization.GetVariationData().dealComplete.tricks;
        this.nodeGeneralLoc = AppLocalization.GetSharedData().general;
        this.nodeTheme = ThemeDataManager.GetVariationData().dealComplete.tricks;
    }

    public override Build(): void
    {
        // > build title
        super.Build();
        this.add(this.nsContentBg);

        // refs
        const headerStyle = {
            color: AppSettings.colors.whiteString, 
            fontSize: "36px",
            align: "center",
            fontFamily: AppSettings.fontFamilies.MontserratBold,
            metrics: AppSettings.metrics.montserratBold36,
        };
        // const headerTextureData = {texture:LoaderFileKeys.ui, frame:"results-tricks-header-bg.png"};
        // const itemBgTextureData: TextureData = {texture:LoaderFileKeys.ui, frame:"results-tricks-listItem-bg.png"};
        const headerTextureData = {texture:LoaderFileKeys.ui, frame:"rect-2x2-transparent.png"};
        const itemBgTextureData: TextureData = {texture:LoaderFileKeys.ui, frame:"rect-2x2-transparent.png"};

        // header
        // - top most table row
        const header: TricksHeaderItem = new TricksHeaderItem(this.scene);
        header.Init(
            headerTextureData, headerStyle,
            LayoutDataManager.GetSharedData().general.screen.header.delimiterLine.alpha,
        );
        header.Build();
        header.SetData(
            this.nodeGeneralLoc.playersAxes[0], 
            this.nodeGeneralLoc.playersAxes[1], 
            this.nodeGeneralLoc.playersAxes[2], 
            this.nodeGeneralLoc.playersAxes[3]
        );
        this.add(header);
        this.header = header;

        // 8 Tricks per Deal
        for (let i:number = 0; i<8; i++) {
            const item = new TricksListItem(this.scene);
            item.Init(
                itemBgTextureData,
                this.delimiterLineAlpha,
            );
            item.Build();
            this.items.push(item as any);
            this.add(item);
        }

        // this.UpdateFromLocalizationChange();
    }

    /**
     * Localized language changed. Update text.
     */
    public UpdateFromLocalizationChange(): void
    {
        this.nodeLoc = AppLocalization.GetVariationData().dealComplete.tricks;
        this.nodeGeneralLoc = AppLocalization.GetSharedData().general;
        const sTitle: string = this.nodeLoc.title.itemLabel;

        this.btnTitle.SetLabel(sTitle);

        (this.header as TricksHeaderItem).SetData(
            this.nodeGeneralLoc.playersAxes[0], 
            this.nodeGeneralLoc.playersAxes[1], 
            this.nodeGeneralLoc.playersAxes[2], 
            this.nodeGeneralLoc.playersAxes[3]
        );
    }

    public SetData(inputData: TrickData[]): void
    {
        // this.items.forEach((item:TricksListItem, i)=>{
        this.items.forEach((item:any, i)=>{
            (item as TricksListItem).SetData(
                inputData[i],
                this.items.length != i+1,
            );
        });
    }

    public override SetWidth(width: number): void
    {
        // position and calculate size for all base items
        super.SetWidth(width);
        
        this.RedrawBorder();
    }
}